import axios from "axios";

export const throwError = (message: string, error: unknown) => {
  if (axios.isAxiosError(error)) {
    throw new Error((error?.response?.data as string) || message);
  }
  throw new Error(message);
};
